export default __webpack_public_path__ + "static/Logo-D-Vert-3d905e1278c35da220d7f5e61a09168a.svg";